
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mainStore, companyStore } from '@/store';
import { ICompanyPontoAcompanhamentoItem } from '@/interfaces/company';

@Component
export default class UploadFilesPontoAprovado extends Vue {
  @Prop({ type: Object, default: () => {} }) readonly propItem;
  @Prop({ type: String, default: '' }) readonly propTipoUpload;

  public isLoading = false;
  public isLoadingBtn = false;
  public modelFiles: any = [];
  public companyPontoAcompanhamentoItem: any = [];
  public isLoadingDownload = false;
  public file_status = '';
  public observacaoArquivo = '';

  get tipoItems() {
    return [
      {
        id: 2,
        name: 'Aprovar ' + this.propTipoUpload,
        description: 'Aprovar upload de arquivo do ponto',
      },
    ];
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public async handleOpenFile() {
    this.isLoadingDownload = true;
    window.open(this.propItem.download_url);
    this.isLoadingDownload = false;
  }

  public handleAprovarArquivo() {
    this.$swal({
      title: 'Confirma aprovação do arquivo?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        this.isLoadingBtn = true;

        let acompanhamentoPontoItem: ICompanyPontoAcompanhamentoItem = {
          id: this.propItem.id,
          acompanhamento_id: this.propItem.acompanhamento_id,
          observacao: this.observacaoArquivo,
          status: 1,
          nome_arquivo: this.propItem.nome_arquivo,
          created_by_id: this.propItem.created_by_id,
          created_by_name: this.propItem.created_by_name,
          user_id: this.currentUser.id,
        };
        this.companyPontoAcompanhamentoItem = await companyStore.updateCompanyPontoAcompanhamentoItem(
          acompanhamentoPontoItem
        );
      }

      if (this.companyPontoAcompanhamentoItem.id > 0) {
        this.$swal.fire('Arquivo aprovado com sucesso!', '', 'success');
        this.$emit('getPropState', Math.floor(Math.random() * 200));
        this.file_status = 'Aprovado';
      } else {
        this.$swal.fire('Falha ao salvar a aprovação.', 'Tente novamente!', 'error');
      }

      this.isLoadingBtn = false;
    });
  }

  public handleReprovarArquivo() {
    this.$swal({
      title: 'Confirma a reprovação do arquivo?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Sim, eu confirmo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.isLoadingBtn = true;

        let acompanhamentoPontoItem: ICompanyPontoAcompanhamentoItem = {
          id: this.propItem.id,
          acompanhamento_id: this.propItem.acompanhamento_id,
          observacao: this.observacaoArquivo,
          status: 2,
          nome_arquivo: this.propItem.nome_arquivo,
          created_by_id: this.propItem.created_by_id,
          created_by_name: this.propItem.created_by_name,
          user_id: this.currentUser.id,
        };
        this.companyPontoAcompanhamentoItem = await companyStore.updateCompanyPontoAcompanhamentoItem(
          acompanhamentoPontoItem
        );
      }

      if (this.companyPontoAcompanhamentoItem.id > 0) {
        this.$swal.fire('Arquivo reprovado com sucesso!', '', 'success');
        this.$emit('getPropState', Math.floor(Math.random() * 200));
        this.file_status = 'Reprovado';
      } else {
        this.$swal.fire('Falha ao salvar a reprovação.', 'Tente novamente!', 'error');
      }
      this.isLoadingBtn = false;
    });
  }

  public async mounted() {
    this.isLoading = true;
    this.modelFiles = this.propItem.blob;
    this.file_status = this.propItem.status_arquivo;
    this.observacaoArquivo = this.propItem.observacao;
    this.isLoading = false;
  }
}
